






import { Component, Prop, Vue } from 'vue-property-decorator'
import PageLayout from '@/components/page/PageLayout.vue'
import DispatchForm from './DispatchForm.vue'

@Component({
	name: 'DispatchUpdate',
	components: {
		PageLayout,
		DispatchForm,
	},
})
export default class DispatchUpdate extends Vue {}
